<template>
  <v-row justify="center">
    <v-dialog v-model="openAddNewModal" fullscreen hide-overlay transition="dialog-bottom-transition" @keydown.esc="$emit('closeAddNew')">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('closeAddNew')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title ? title : 'Create New'}}</v-toolbar-title>
        </v-toolbar>
        <component :is="module" :isFromPopup="true"/>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import machineType from '@/modules/machineType/create.vue'
import userRole from '@/modules/user/userRole/create.vue'
import weldingProcess from '@/modules/weldingProcess/create.vue'
import weldingType from '@/modules/weldingType/create.vue'
import jointType from '@/modules/jointType/create.vue'
export default {
  watch: {
    isOpen (val) {
      this.openAddNewModal = val
    }
  },
  props: ['module', 'isOpen', 'title'],
  components: { userRole, machineType, weldingProcess, weldingType, jointType },
  created () {
  },
  data () {
    return {
      openAddNewModal: this.isOpen
    }
  }
}
</script>
